import { Text, TextProps } from "@chakra-ui/react";

import {
  SECONDS_IN_DAY,
  SECONDS_IN_HOUR,
  SECONDS_IN_MINUTE,
} from "@/constants/shared";
import { useCountdown } from "@/hooks/useCountdown";

type CountdownFormat = "full" | "HMS" | "HM" | "DH" | "default";

interface CountdownProps extends TextProps {
  date?: Date;
  format?: CountdownFormat;
}

export const Countdown = ({
  date,
  format = "default",
  ...textStyleOverrides
}: CountdownProps) => {
  const { days, hours, minutes, seconds } = useCountdown(date);
  if (format === "default") {
    // Hours:Minutes:Seconds
    return (
      <Text minW={70} {...textStyleOverrides}>
        {hours}:{minutes}:{seconds}
      </Text>
    );
  }

  if (format === "HM") {
    // Hours:Minutes
    return (
      <Text minW={50} {...textStyleOverrides}>
        {parseInt(hours, 10)}h {minutes}m
      </Text>
    );
  }

  const totalSeconds =
    parseInt(hours, 10) * SECONDS_IN_HOUR +
    parseInt(minutes, 10) * SECONDS_IN_MINUTE +
    parseInt(seconds, 10);
  const remainingHours = Math.floor(
    (totalSeconds % SECONDS_IN_DAY) / SECONDS_IN_HOUR,
  );

  if (format === "DH") {
    //Days:Hours
    return (
      <Text minW={50} {...textStyleOverrides}>
        {parseInt(days, 10)}d {remainingHours}h
      </Text>
    );
  }

  const remainingMinutes = Math.floor(
    (totalSeconds % SECONDS_IN_HOUR) / SECONDS_IN_MINUTE,
  );

  return (
    <Text minW={70} {...textStyleOverrides}>
      {String(days).padStart(2, "0")}d {String(remainingHours).padStart(2, "0")}
      h {String(remainingMinutes).padStart(2, "0")}m
    </Text>
  );
};
